<div class="kt-container  kt-grid__item kt-grid__item--fluid">

    <!--Begin::App-->
    <div class="kt-grid kt-grid--desktop kt-grid--ver kt-grid--ver-desktop kt-app">

        <!--Begin:: App Aside Mobile Toggle-->
        <button class="kt-app__aside-close" id="kt_user_profile_aside_close">
            <i class="la la-close"></i>
        </button>

        <!--End:: App Aside Mobile Toggle-->

        <!--Begin:: App Aside-->
        <div class="kt-grid__item kt-app__toggle kt-app__aside" id="kt_user_profile_aside">

            <!--begin:: Widgets/Applications/User/Profile4-->
            <div class="kt-portlet kt-portlet--height-fluid-">
                <div class="kt-portlet__body">

                    <!--begin::Widget -->
                    <div class="kt-widget kt-widget--user-profile-4">
                        <div class="kt-widget__head">
                            <div class="kt-widget__media">
                                <img class="kt-widget__img kt-hidden-" *ngIf="isImage" src="{{assetsPath + userBasicInfo.image}}" alt="image">
                                <img class="kt-widget__img kt-hidden-" *ngIf="!isImage" src="/assets/media/users/default.jpg" alt="image">
                                <div
                                    class="kt-widget__pic kt-widget__pic--danger kt-font-danger kt-font-boldest kt-font-light kt-hidden">
                                    AD
                                </div>
                            </div>
                            <div class="kt-widget__content">
                                <div class="kt-widget__section">
                                    <a href="#" class="kt-widget__username">
                                        {{ userBasicInfo.displayName}}
                                    </a>
                                    <div class="kt-widget__button">
                                        <span class="btn btn-label-warning btn-sm">Aktif Gönüllü</span> <br *ngIf="userBasicInfo.isAlumni"><br *ngIf="userBasicInfo.isAlumni">
                                        <span class="btn btn-label-brand btn-sm" *ngIf="userBasicInfo.isAlumni">Mezun</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="kt-widget__body">
                            <a [routerLink]="['/my-profile']" class="kt-widget__item">
                                Genel Bilgiler
                            </a>
                            <a [routerLink]="['/update-my-basic-information']"
                                class="kt-widget__item">
                                Temel Bilgilerimi Güncelle
                            </a>
                            <a [routerLink]="['/update-my-role-settings']" class="kt-widget__item">
                                Gönüllülük Alanlarım
                            </a>
                            <a [routerLink]="['/update-my-password']" class="kt-widget__item">
                                Şifremi Değiştir
                            </a>
                            <a [routerLink]="['/my-profession-list']" class="kt-widget__item">
                                Kariyer Bilgilerim
                            </a>
                            <a [routerLink]="['/my-education-list']" class="kt-widget__item kt-widget__item--active">
                                Eğitim Bilgilerim
                            </a>
                        </div>
                    </div>

                    <!--end::Widget -->
                </div>
            </div>

            <!--end:: Widgets/Applications/User/Profile4-->

            <!--Begin:: Portlet-->
            <div class="kt-portlet">
                <div class="kt-portlet__body">
                    <div class="kt-widget1 kt-widget1--fit">
                        <div class="kt-widget1__item">
                            <div class="kt-widget1__info">
                                <h3 class="kt-widget1__title">Başvurularım</h3>
                                <span class="kt-widget1__desc">Aktif başvuru sayısı</span>
                            </div>
                            <span class="kt-widget1__number kt-font-brand">0</span>
                        </div>
                        <div class="kt-widget1__item">
                            <div class="kt-widget1__info">
                                <h3 class="kt-widget1__title">Rozetlerim</h3>
                                <span class="kt-widget1__desc">Rozet sayısı</span>
                            </div>
                            <span class="kt-widget1__number kt-font-success">0</span>
                        </div>
                    </div>
                </div>
            </div>

            <!--end:: Portlet-->
        </div>

        <!--End:: App Aside-->

        <!--Begin:: App Content-->
        <div class="kt-grid__item kt-grid__item--fluid kt-app__content">
            <div class="row">
                <div class="col-xl-12">
                    <div class="kt-portlet">
                        <div class="kt-portlet__head">
                            <div class="kt-portlet__head-label">
                                <h3 class="kt-portlet__head-title">Yeni eğitim bilgisi ekle</h3>
                            </div>
                        </div>
                        <form [formGroup]="updateMyeducationForm" (ngSubmit)="save()" class="kt_login_form">
                            <div class="kt-portlet__body">
                                <div class="kt-section kt-section--first">
                                    <div class="kt-section__body">
                                        <div class="form-group">
                                            <label for="educationLevel" class="col-form-label">Eğitim seviyesi</label>
                                            <ng-select name="type" id="educationLevel" labelForId="educationLevel" bindValue="code"
                                                style="width: 100%; padding: 5px; float: left;clear: both;" [items]="educationTypes" bindLabel="text"
                                                [(ngModel)]="education.level" (change)="educationLevel()"
                                                placeholder="Eğitim seviyesi.." formControlName="educationLevel">
                                            </ng-select>
                                            <small class="form-text text-warning" *ngIf="f.educationLevel.errors?.required">Lütfen eğitim seviyesi seçiniz!</small>
                                        </div>  

                                        <div class="form-group" *ngIf="isUniversity">
                                            <label for="universityId" class="col-form-label">Üniversite</label>
                                            <ng-select name="universityId" id="universityId" labelForId="universityId"
                                                bindValue="id" style="width: 100%; padding: 5px; float: left;clear: both;" placeholder="Üniversite" [items]="universities"
                                                bindLabel="name" formControlName="universityId">
                                            </ng-select>
                                        </div>

                                        <div class="form-group" style="margin-top: 40px;" *ngIf="isUniversity">
                                            <label class="kt-checkbox">
                                                <input type="checkbox" name="isOtherUniversity" class="form-control" formControlName="isOtherUniversity" (change)="otherUniversity()" [(ngModel)]="education.isOtherUniversity">
                                                Diğer
                                                <span></span>
                                            </label>
                                        </div>
                                        <div class="form-group" *ngIf="isSchoolName">
                                            <label class="col-form-label">Okul adı</label>
                                            <input formControlName="schoolName" type="text" class="form-control"
                                                placeholder="Okul adı...">
                                            <small class="form-text text-warning"
                                                *ngIf="f.schoolName.errors?.required">Lütfen okul adı giriniz!</small>
                                            <small class="form-text text-warning"
                                                *ngIf="f.schoolName.errors?.maxlength">Lütfen en fazla 100 haneli bir isim giriniz!</small>
                                        </div>
                                        <div class="form-group" *ngIf="isDepartmant">
                                            <label class="col-form-label">Departman</label>
                                            <input formControlName="departmant" type="text" class="form-control"
                                                placeholder="Departmanınızı giriniz...">
                                            <small class="form-text text-warning"
                                                *ngIf="f.departmant.errors?.required">Lütfen departmanınızı giriniz!</small>
                                            <small class="form-text text-warning"
                                                *ngIf="f.departmant.errors?.maxlength">Lütfen en fazla 100 haneli bir departman giriniz!</small>
                                        </div>
                                        <div class="form-group">
                                            <label for="startDate" class="col-form-label">Başlangıç tarihi</label>
                                            <input class="form-control" type="date" id="startDate"
                                                formControlName="startDate" placeholder="Başlangıç tarihi" name="startDate">
                                            <small class="form-text text-warning" *ngIf="f.startDate.errors?.required">Lütfen eğitim başlangıç
                                                tarihinizi giriniz!</small>
                                        </div>
                                        <div class="form-group">
                                            <label for="endDate" class="col-form-label">Çıkış tarihi</label>
                                            <input class="form-control" type="date" id="endDate"
                                                formControlName="endDate" placeholder="Çıkış tarihi" name="endDate">
                                            <small class="form-text text-warning" *ngIf="f.endDate.errors?.required">Lütfen eğitim bitiş
                                                tarihinizi giriniz!</small>
                                        </div>
                                        <div class="form-group">
                                            <label class="kt-checkbox w-100">
                                                <input type="checkbox" name="isContinue" class="form-control" formControlName="isContinue" [(ngModel)]="education.isContinue" (change)="disableEndDate()">
                                                Devam ediyor musunuz?
                                                <span></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="kt-portlet__foot">
                                <div class="kt-form__actions">
                                    <div class="row">
                                        <div class="col-lg-9 col-xl-9">
                                            <button type="submit" class="btn btn-success btn-bold">Kaydet</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!--End:: App Content-->
    </div>

    <!--End::App-->
</div>